import { cssVariables } from "@/utils/utils";
import { Flex, Progress } from "antd";

type Props = {
  avatar: React.ReactNode;
  label: React.ReactNode;
  popover?: React.ReactNode;
  remainingDays: number;
  totalDays: number;
};

export const ExpertiseListItem = ({ avatar, label, popover, remainingDays, totalDays }: Props) => {
  return (
    <Flex
      align="center"
      gap={16}
      style={{
        backgroundColor: "white",
        height: 85,
        borderRadius: 18,
        padding: "0 24px",
        border: "1px solid #f0f0f0",
      }}
    >
      {avatar}

      <div style={{ flex: "1 0", width: 0, color: cssVariables.colorText }}>
        <Flex justify="space-between" align="end">
          <span>{label}</span>

          {popover}
        </Flex>

        <Progress
          percent={100 - Math.round((remainingDays * 100) / totalDays)}
          status="active"
          showInfo={false}
          size={["100%", 10]}
          strokeColor={
            remainingDays > 90
              ? cssVariables.colorBlue
              : remainingDays > 14
                ? cssVariables.colorYellow
                : cssVariables.colorRed
          }
        />
      </div>
    </Flex>
  );
};
